import { PersistConfig, createTransform, persistStore, persistReducer } from "redux-persist";
import { store, buildStore } from "Data/Redux/Store";
import { disconnectOnLogout, logoutOnUnauthorized } from "Data/Redux/Middleware/Middleware";
import { AppState, rootReducer } from "Data/Redux/Reducers";
import storage from "redux-persist/lib/storage";
import produce from "immer";
import { IItem, IPaginatedDataSet } from "Interfaces";
import { defaultPaginatedStateOptions } from "Data/Objects/Redux";
import listenerMiddleware from "Data/Redux/Middleware/Listener";

const persistStateTransform = createTransform(
	(inboundState, key) => {
		switch (key) {
			case "Items": {
				const typedState: IPaginatedDataSet<IItem> = inboundState as IPaginatedDataSet<IItem>;

				return produce(typedState, (draft) => {
					draft.data = [];
					draft.lastPage = -1;
					draft.options = { ...typedState?.options, ...defaultPaginatedStateOptions };
				});
			}

			default:
				return inboundState;
		}
	}
);

const persistConfig: PersistConfig<AppState> = {
	key: "root",
	blacklist: [ "Order" ],
	storage,
	transforms: [ persistStateTransform ]
};

buildStore(
	persistReducer(persistConfig, rootReducer),
	{},
	[ listenerMiddleware.middleware, disconnectOnLogout, logoutOnUnauthorized ]
);

export const persistor = persistStore(store);
